import { defineFcm } from '../shared/factory';

export const FCM_STARTER_ONBOARDING_SUNRISE_TOGGLE = defineFcm('starter_onboarding_sunrise_toggle')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-starfish',
		scope: 'corgi-front-end',
		context: 'starter onboarding',
		description: 'Toggles sunrise experience in starter onboarding',
		import: false,
		deprecated: 'Sunrise experience productized; front-end usage removed; safe to delete after 2026-07-28',
	});
